import * as S from "./styles";

export type ErrorMessageProps = {
  errorMessage?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessage = undefined,
}) => {
  return !!errorMessage ? (
    <S.ErrorMessageContainer>
      <S.ErrorMessageMessage>{errorMessage}</S.ErrorMessageMessage>
    </S.ErrorMessageContainer>
  ) : null;
};

export default ErrorMessage;
